import { Controller } from "@hotwired/stimulus"

// Note composer on a field card (card #2617) -- /field/cards/:id.
//
// Online only, like the response notes feed: offline, the textarea and send
// button are disabled and the placeholder says why, so a tasker never types a
// note into something that can't send. Connectivity is the app's own
// field:online flag (field_network_health.js) plus the browser's, re-checked
// on the same events field_sync_banner_controller.js listens to.
//
// The form posts as a normal Turbo form; the server answers with a Turbo
// Stream that appends the note and replaces this composer, so this controller
// holds no markup.
//
// Usage: see app/views/field/cards/_composer.html.erb
export default class extends Controller {
  static targets = ["form", "input", "submit"]
  static values = {
    onlinePlaceholder: { type: String, default: "" },
    offlinePlaceholder: { type: String, default: "" }
  }

  static EVENTS = ["field:online", "field:offline", "field:health-changed", "online", "offline"]

  connect() {
    this._render = () => this._renderConnectivity()
    this.constructor.EVENTS.forEach(name => window.addEventListener(name, this._render))
    this._renderConnectivity()
  }

  disconnect() {
    this.constructor.EVENTS.forEach(name => window.removeEventListener(name, this._render))
  }

  // turbo:submit-end -- on success the stream has already appended the note;
  // bring it into view above the composer.
  submitted(event) {
    if (!event.detail?.success) return

    const notes = document.getElementById("field_card_activities")
    notes?.lastElementChild?.scrollIntoView({ block: "end", behavior: "smooth" })
  }

  // -- private --

  _renderConnectivity() {
    const offline = localStorage.getItem("field:online") === "false" || navigator.onLine === false

    if (this.hasInputTarget) {
      this.inputTarget.disabled = offline
      this.inputTarget.placeholder = offline ? this.offlinePlaceholderValue : this.onlinePlaceholderValue
    }
    if (this.hasSubmitTarget) this.submitTarget.disabled = offline
  }
}
